import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const FaqGetList = createAsyncThunk(
  "FaqGetList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.MACHINE_FAQ_LIST,
          body: data,
        },
        false
      );
      let response = apiResponse(false, resData);
      return response;
    } catch (error) {}
  }
);

const initialState = {
  FaqGetListData: {
    data: null,
    error: null,
  },
};

const MachineFaqSlice = createSlice({
  name: "MACHINEFAQ",
  initialState,
  reducers: {
    // setLoader: (state, action) => {
    //   state.isLoading = action.payload;
    // },
    //   setWorkFlowGetListData: (state) => {
    //     state.WorkFlowGetListData.data = null;
    //   },
    //   setGetWorkFlowByID: (state) => {
    //     state.GetWorkFlowByIDData.data = null;
    //   },
  },

  extraReducers: (builder) => {
    builder
      .addCase(FaqGetList.fulfilled, (state, action) => {
        state.FaqGetListData.data = action.payload;
      })
      .addCase(FaqGetList.rejected, (state, action) => {
        state.FaqGetListData.error = action.error.message;
      });
  },
});

// export const { setLoader } = MachineFaqSlice.actions;
export default MachineFaqSlice.reducer;
